import { render, staticRenderFns } from "./clasificador.vue?vue&type=template&id=66db25c3&scoped=true&"
import script from "./clasificador.vue?vue&type=script&lang=ts&"
export * from "./clasificador.vue?vue&type=script&lang=ts&"
import style0 from "./clasificador.vue?vue&type=style&index=0&id=66db25c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66db25c3",
  null
  
)

export default component.exports